import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Stack } from '@mui/material';
import { NotificationToast } from 'cprime-foundational-components';

const ToastNotification = ({
  subtitle,
  title,
  type,
  open,
  horizontalPosition,
  verticalPosition,
}) => {
  const [notification, setNotification] = useState({
    severity: type,
    open: open,
    title: title,
    message: subtitle,
  });

  return (
    <>
      {notification.open && (
        <Stack>
          <Box
            sx={{
              position: 'fixed',
              top: 120,
              right: 16,
              zIndex: 1400,
            }}
          >
            <NotificationToast
              severity={type}
              title={title}
              message={subtitle}
              timeout
              horizontalPosition={horizontalPosition}
              verticalPosition={verticalPosition}
              handleClose={() => setNotification((old) => ({ ...old, open: false }))}
            />
          </Box>
        </Stack>
      )}
    </>
  );
};

ToastNotification.defaultProps = {
  open: false,
};

ToastNotification.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['info', 'success', 'warning', 'error']).isRequired,
  horizontalPosition: PropTypes.oneOf(['center', 'left', 'right']).isRequired,
  verticalPosition: PropTypes.oneOf(['bottom', 'top']).isRequired,
  open: PropTypes.bool.isRequired,
};

export default ToastNotification;
